import { Injectable } from '@angular/core';

import { Field, SignatureRuleLogic } from '@site-mate/dashpivot-shared-library';

import { TmpI18NService } from 'app/i18n/tmp-i18n.service';

@Injectable({
  providedIn: 'root',
})
export class ApprovalSignatureService {
  constructor(private readonly i18nService: TmpI18NService) {}

  hasIncompleteRule(approvalSignatures: Field[]) {
    const signaturesWithLogic =
      approvalSignatures.filter((signature) => signature.signatureRules?.length) ?? [];

    return signaturesWithLogic.some((signature) => this.validateRuleFields(signature.signatureRules));
  }

  isValidRule(rule: SignatureRuleLogic): boolean {
    return !!rule.type && !!rule.operator && !!rule.values?.length && !!rule.action;
  }

  validateRuleFields(rules: SignatureRuleLogic[]) {
    rules.forEach((rule) => {
      rule._invalidInputs = [];

      if (!rule.type) {
        rule._invalidInputs.push(`type-${rule._id}`);
      }

      if (!rule.operator) {
        rule._invalidInputs.push(`operator-${rule._id}`);
      }

      if (!rule.values?.length) {
        rule._invalidInputs.push(`values-${rule._id}`);
      }

      if (!rule.action) {
        rule._invalidInputs.push(`action-${rule._id}`);
      }

      if (rule._invalidInputs?.length) {
        rule._invalid = true;
        rule._invalidMessage = this.i18nService.getMessage('inputRequiredError');
      } else {
        rule._invalid = false;
        rule._invalidMessage = '';
      }
    });

    return rules.some((rule) => rule._invalidInputs?.length);
  }
}
